import React, { useState, useEffect} from "react";
import { Box, Grid, List, ListItem, ListItemButton, ListItemText, TextField, Typography, Paper, IconButton, Tooltip } from "@mui/material";
import HeaderBar from "../Header/HeaderBar";
import AddIcon from "@mui/icons-material/Add";
import AddCell from "./AddCell";
import ManageLibrary from "./ManageLibrary";
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from "@mui/material/InputAdornment"
import Breadcrumbs from '@mui/material/Breadcrumbs';
import "./LibraryManager.css"

import { getLibraryByUserId } from "../../services/libraryService";
import { getCellsByLibraryId } from "../../services/cellService";
import EditCell from "./EditCell";
import { getViewDiagramById, getViewsByCellId } from "../../services/viewService";
import EditView from "./EditView";
import GraphPreview from "./GraphPreview";
import LibraryWarnMessage from "./LibraryWarnMessage";
import { markPredefinedLibraries } from "../../utils/libraryUtils";
import NewLibrary from "./NewLibrary";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import MarginIcon from '@mui/icons-material/Margin';
import folderImage from '../../assets/images/folder.png';
import schematicEditor from '../../assets/images/schematic_editor.png';

const LibraryManager = () => {
  const navigate = useNavigate();
  const [librarySearch, setLibrarySearch] = useState("");
  const [cellSearch, setCellSearch] = useState("");
  const [selectedLibrary, setSelectedLibrary] = useState(null);
  const [selectedCell, setSelectedCell] = useState(null);
  const [openManageLibrary, setOpenManageLibrary] = useState(false);
  const [selectedViewIndex, setSelectedViewIndex] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [libraryData,setLibraryData]= useState([]);
  const [cells, setCells] = useState([]);
  const [viewsData, setViewsData]= useState([]);
  const [libraryId, setLibraryId] = useState('');
  const [cellId, setCellId] = useState('');
  const [openEditCell, setOpenEditCell] = useState(false);
  const [openEditView, setOpenEditView] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const [diagram_xml, setDiagramXml] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [protectedLibraries, setProtectedLibraries] = useState([])
  const [createNewLib, setCreateNewLib] = useState(false);

 const userId = localStorage.getItem('user_id');
 const isProtected = selectedLibrary?.isPredefined;

  useEffect(() => {
    getLibraryData();
  }, []);

  useEffect(() => {
    if (libraryId) {
      getCellData();
    }
  }, [libraryId]);

  useEffect(() => {
    if (cellId) {
      getViewsData();
    }
  }, [cellId]);

  const getLibraryData = async () => {
    let fetchPredefined = true;
    const response = await getLibraryByUserId(userId,fetchPredefined);    
    if(!response.success) return;
    
    const data = response.body;
    const markedLibraries = markPredefinedLibraries(data);
    const hasCustomLibrary = markedLibraries.some(
      lib => lib.isPredefined === false
    );
    setCreateNewLib(!hasCustomLibrary);
    setLibraryData(data);
    setProtectedLibraries(markedLibraries);
  }

  const getCellData = async () => {
    const response = await getCellsByLibraryId(libraryId);    
    if(!response.success) return;    
    const data = response.body;    
    setCells(data);
  }

  const getViewsData = async () => {
    const response = await getViewsByCellId(cellId);
    if(!response.success) return;
    const data = response.body;
    setViewsData(data);
  }
  
  const filteredLibraries = libraryData.filter((lib) =>
    lib.name.toLowerCase().includes(librarySearch.toLowerCase())
  );

  const filteredCells = selectedLibrary
    ? cells.filter((cell) =>
      cell.name.toLowerCase().includes(cellSearch.toLowerCase())
    )
    : [];

  const views = selectedLibrary && selectedCell
      ? viewsData
      : [];

  const handleManageLibraryClick  = () => {
    setOpenManageLibrary(true);
    setSelectedLibrary(null)
  };

  const handleEditLibraryClick = (lib) => {
    setSelectedLibrary(lib);
    setOpenManageLibrary(true);
  }

  const handleEditCellClick  = (cell) => {
    setSelectedCell(cell);
    setOpenEditCell(true);
  };

  const handleEditView = (view) => {
    setOpenEditView(true);
    setSelectedView(view);
  }

const handleViewClick = async (view_id, idx) => {  
  if (selectedViewIndex === idx) return;
  try {
    const response = await getViewDiagramById(view_id);
    if(!response.success) return;
    const data = response.body;
    if (data.diagram_xml) {
      setDiagramXml(data.diagram_xml);
    } else {
      setDiagramXml(""); 
    }
  } catch (error) {
    console.error("Error fetching view diagram:", error);
    setDiagramXml("");
  }
};

const handleProtectedNameDetected = () => {
  setShowWarning(true);
};

const openAddLibrary = () => {
  setCreateNewLib(false);
  setOpenManageLibrary(true);
};

  return (
    <>
        <title>Library Manager</title>
        <meta name="description" content="Manage and edit your libraries" />
        {/* <meta name="robots" content="index, follow" /> */}
      {/* <HeaderBar /> */}
      <Box        
        sx={{ width: "100%", boxSizing: "border-box", padding:"0 16px" }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', backgroundColor:"#e8ebeb", padding:"10px", borderRadius:"6px", display: "flex", alignItems: "center",  gap: "6px" }}>
          <span><img alt="Library Manager" src={folderImage } /> </span>
          <span>Library Manager</span>
        </Typography>
        <Grid
          container
          spacing={3}
          sx={{
            // height: "90%",
            width: "100%",
            border: "1px solid gray",
            backgroundColor: "#fff",
            padding: 2,
            // marginBottom:'65px',
            borderRadius: 2,
            
          }}
        >
          {/* Library Section */}
          <Grid size={{xs:12, sm:4}} >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <TextField
                fullWidth
                label={ 
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <LibraryAddIcon sx={{ fontSize: 14 }} />
                      Library
                  </Box>
                }
                variant="outlined"
                size="small"
                value={librarySearch}
                onChange={(e) => setLibrarySearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                      <InputAdornment position="end" sx={{ pointerEvents: "none" }}>
                        <SearchIcon/>
                      </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingRight: 1
                  },
                }}
              />
              <Tooltip title="Add Library" arrow>
                <AddIcon
                  fontSize="medium"
                  sx={{
                    ml: 1,
                    cursor: "pointer",
                    color: "primary.main",
                    "&:hover": { color: "primary.dark" },
                  }}
                  onClick={handleManageLibraryClick}
                />
              </Tooltip>
            </Box>
            <Box
              sx={{
                border: "1px solid lightgray",
                borderRadius: 1,
                height: { md:300, xs: 150 },
                overflowY: `${filteredLibraries.length > 0 ? 'auto' : 'hidden'}`
              }}
            >
              {filteredLibraries.length === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                  }}
                >
                  <Typography color="#5e5e5c">No data</Typography>
                </Box>
              ) : (
                <List>
                  {protectedLibraries.filter((lib) =>
                    lib.name.toLowerCase().includes(librarySearch.trim().toLowerCase())).map((lib) => (
                    <ListItem
                      key={lib.libraryId}
                      disablePadding
                      className="list-item"
                      secondaryAction={
                        <Box className="secondary-action-icon">
                          <Tooltip title="Edit Library" arrow>
                          {!lib.isPredefined && (
                          <IconButton
                            edge="end"
                            aria-label="edit"
                            sx={{
                              cursor: 'pointer',
                            }}
                            onClick={() => { handleEditLibraryClick(lib) }}
                          >
                            <EditIcon sx={{ color: "primary.main" }} />
                          </IconButton>
                            )}
                          </Tooltip>
                        </Box>
                      }
                    >
                      <ListItemButton
                        selected={selectedLibrary?.name === lib.name}
                        onClick={() => {
                          setSelectedLibrary(lib);
                          setSelectedCell(null);
                          setShowImage(false);
                          setLibraryId(lib.library_id);
                          setCellId('');
                          setViewsData([]);
                          setDiagramXml('');
                        }}
                        sx={{
                          cursor: 'default',
                        }}
                      >
                        <ListItemText primary={lib.name} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Grid>

          {/* Cell Section */}
          <Grid size={{ xs: 12, sm: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <TextField
                fullWidth
                label={ 
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <MarginIcon sx={{ fontSize: 14 }} />
                      Cell
                  </Box>
                }
                variant="outlined"
                size="small"
                value={cellSearch}
                onChange={(e) => setCellSearch(e.target.value)}
                disabled={!selectedLibrary}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ pointerEvents: "none" }}>
                        <SearchIcon/>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingRight: 1
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                border: "1px solid lightgray",
                borderRadius: 1,
                height: { md:300, xs: 150 },
                overflowY: `${filteredCells.length > 0 ? 'auto' : 'hidden'}`
              }}
            >
              <List>
                {filteredCells.length > 0 ? (
                  filteredCells.map((cell) => (
                    <ListItem
                      key={cell.cell_id}
                      disablePadding
                      className="list-item"
                      secondaryAction={
                        <Box className="secondary-action-icon">
                          <Tooltip title="Edit Cell" arrow>
                          {!isProtected &&
                          <IconButton
                            edge="end"
                            aria-label="edit"
                            sx={{
                              cursor: 'pointer',
                            }}
                            onClick={() => { handleEditCellClick(cell) }}
                          >
                            <EditIcon sx={{ color: "primary.main" }} />
                          </IconButton>
                          }
                          </Tooltip>
                        </Box>
                      }
                    >
                      <ListItemButton
                        selected={selectedCell === cell}
                        onClick={() => {
                          setSelectedCell(cell);
                          setShowImage(false);
                          setSelectedViewIndex(null);
                          setCellId(cell.cell_id)
                        }}
                        sx={{
                          cursor: 'default',
                        }}
                      >
                        <ListItemText primary={cell.name} />
                      </ListItemButton>
                    </ListItem>
                  ))
                ) : (
                  <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px",
                      }}
                    >
                      <Typography color="#5e5e5c">No data</Typography>
                        <Tooltip title="Go to Schematic Editor to create a new cell" arrow>
                          <IconButton onClick={() => navigate("/schematicEditor")}>
                            <img
                              src={schematicEditor}
                              alt="schematiceditor"
                            />
                          </IconButton>
                        </Tooltip>
                    </Box>
                )}
              </List>
            </Box>
          </Grid>

          {/* Views Section */}
          <Grid size={{ xs: 12, sm: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1, height:'35px' }}>
              <Typography sx={{ height: "40px", display: "flex", alignItems: "center" }}>
                Cell-view
              </Typography>
            </Box>
            <Box
              sx={{
                border: "1px solid lightgray",
                borderRadius: 1,
                height: { md:300, xs: 150 },
                overflowY: `${views.length > 0 ? 'auto' : 'hidden'}`
              }}
            >
              <List>
                {views.length > 0 ? (
                  views.map((view, idx) => (
                    <ListItem
                      key={idx}
                      disablePadding
                      className="list-item"
                      secondaryAction={
                        <Box className="secondary-action-icon">
                          <Tooltip title="Edit Cell-view" arrow>
                          {!isProtected &&
                          <IconButton
                            edge="end"
                            aria-label="edit"
                            sx={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditView(view);
                            }}
                          >
                            <EditIcon sx={{ color: "primary.main" }} />
                          </IconButton>
                          }
                          </Tooltip>
                          <Tooltip title="Open in Editor" arrow>
                          {!isProtected &&
                          <IconButton
                            edge="end"
                            aria-label="launch"
                            sx={{ cursor: 'pointer', ml: 1 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate('/schematicEditor', {
                                state: {
                                  payload: {
                                    view_id: view.view_id,
                                    view_name: view.name,
                                    view_type_id: view.view_type_id,
                                    cell_id: selectedCell?.cell_id,
                                    cell_name: selectedCell?.name,
                                    library_id: selectedLibrary?.library_id,
                                    library_name: selectedLibrary?.name
                                  }
                                }
                              })
                            }}
                          >
                            <LaunchIcon sx={{ color: "primary.main" }} />
                          </IconButton>
                          }
                          </Tooltip>
                        </Box>
                      }
                    >
                      <ListItemButton
                        selected={selectedViewIndex === idx}
                        onClick={() => {
                          handleViewClick(view.view_id, idx);
                          setSelectedViewIndex(idx);
                          setShowImage(true);
                        }}
                        sx={{
                          cursor: 'default',
                        }}
                      >
                        <ListItemText primary={view.name} />
                      </ListItemButton>
                    </ListItem>
                  ))
                ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px",
                      }}
                    >
                      <Typography color="#5e5e5c">No data</Typography>
                    </Box>
                )}
              </List>
            </Box>
          </Grid>
        </Grid>

        {/* mxGraph Preview */}
        {showImage && views[selectedViewIndex] && (
          <GraphPreview
            title={
              <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
                <Typography color="black">
                  {selectedLibrary?.name || 'Library'}
                </Typography>
                <Typography color="black">
                  {selectedCell?.name || 'Cell'}
                </Typography>
                <Typography color="black">
                  {views[selectedViewIndex].name}
                </Typography>
              </Breadcrumbs>
            }
            diagram_xml={diagram_xml}
            onClose={() => { 
              setShowImage(false);
              setDiagramXml('');
              setSelectedViewIndex(null);
            }}
          />
        )}

        <ManageLibrary
          libraryPopupOpen={openManageLibrary}
          handleClose={() => setOpenManageLibrary(false)}
          selectedLibrary={selectedLibrary}
          getLibraryData={getLibraryData}
          userId={userId}
          existingLibrary={libraryData}
          onProtectedNameDetected={handleProtectedNameDetected}
          showWarning={showWarning}
        />
        <NewLibrary
          openPopup={createNewLib}
          handleClose={() => setCreateNewLib(false)}
          openAddLibrary={openAddLibrary}
        />
        <LibraryWarnMessage 
          open={showWarning} 
          onClose={() => setShowWarning(false)} 
        />
        <EditCell
          cellPoupOpen={openEditCell}
          handleClose={() => setOpenEditCell(false)}
          selectedCell={selectedCell}
          getCellData={getCellData}
          existingCells={cells}
        />
        <EditView
          viewOpenPopup={openEditView}
          handleClose={() => setOpenEditView(false)}
          selectedView={selectedView}
          getViewsData={getViewsData}
          existingViews={viewsData}
        />
      </Box>
    </>
  );
};

export default LibraryManager;
